
	import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
	import TravelService from '@/services/TravelService';
	import ApiHelper from '@/helpers/api-helper';

	@Component
	export default class TravelFilter extends Vue {
		// N-291: el listado de Presupuestos lo rotula «Destino» y lo pone desde la URL o «Limpiar
		// filtros». Sin estas dos props, todo como siempre.
		@Prop({ default: 'travel_id' }) private label!: string;
		@Prop({ default: null }) private value!: number | null;

		private items: {}[] = [];
		private filter = this.value;

		@Watch('value')
		onValue(valor) {
			this.filter = valor;
		}

		mounted() {
			this.getList();
		}

		getList() {
			TravelService.getSelectorList()
				.then(res => {
					if (res.status === 200) {
						this.prepareOptions(res.data);
					}
				})
				.catch(error => {
					ApiHelper.handleErrors(error, {}, this.$bus);
				});
		}

		prepareOptions(data) {
			this.items = [];
			for (const travel of data) {
				this.items.push({ text: travel.name, value: travel.id });
			}
		}
	}
